import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InterviewStatusTag',
  props: {
    status: {},
    effect: {},
    size: {}
  },
  setup(__props: any) {

const props = __props;

// 获取标签类型
const getTagType = computed(() => {
  if (!props.status) return 'info';
  
  switch (props.status) {
    case 'scheduled':
      return 'warning';
    case 'completed':
      return 'success';
    case 'cancelled':
      return 'danger';
    case 'rescheduled':
      return 'warning';
    case 'in_progress':
      return 'primary';
    case 'not_scheduled':
    default:
      return 'info';
  }
});

// 获取状态文本
const getStatusText = computed(() => {
  if (!props.status) return '未设置';
  
  const statusMap: Record<string, string> = {
    'not_scheduled': '未安排',
    'scheduled': '已安排',
    'completed': '已完成',
    'cancelled': '已取消',
    'rescheduled': '已改期',
    'in_progress': '进行中'
  };
  
  return statusMap[props.status] || props.status;
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(_component_el_tag, {
    type: getTagType.value,
    effect: _ctx.effect || 'light',
    size: _ctx.size || 'default',
    class: "interview-status-tag"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(getStatusText.value), 1)
    ]),
    _: 1
  }, 8, ["type", "effect", "size"]))
}
}

})